export const firebaseConfig = {
  apiKey: "AIzaSyDpy1LQ0Dj-g09kW42C5ypPFCCGpbIr3_U",
  authDomain: "micatalogovirtual-7bfd1.firebaseapp.com",
  databaseURL: "https://micatalogodb.firebaseio.com",
  projectId: "micatalogovirtual-7bfd1",
  storageBucket: "micatalogovirtual-7bfd1.appspot.com",
  messagingSenderId: "232830642721",
  appId: "1:232830642721:web:69e6788956c4a59f3fd160"
};